export function isServerSide(): boolean {
    if (typeof window !== 'undefined') {
        return false;
    }
    return true;
}

export function isDev(): boolean {
    return process.env.NODE_ENV !== 'production';
}
